import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { parseDateOnly } from '@/lib/formatters'
import { type RemovalReason } from '@/models/policyChange'
import type { EditChangeProps } from './EditChange'
import { KIND_LABELS, toIsoDate } from './policyChangeCopy'
import { RemovalFields } from './RemovalFields'
import { saved } from './saveOrToast'

/** Why a unit is leaving and the dates that say when. */
export function EditRemoval({ line, onSave, onClose }: Pick<EditChangeProps, 'line' | 'onSave' | 'onClose'>) {
  const [reason, setReason] = useState<RemovalReason | undefined>(line.removalReason || undefined)
  const [termLetter, setTermLetter] = useState(parseDateOnly(line.termLetterDate))
  const [lastLoad, setLastLoad] = useState(parseDateOnly(line.lastLoadDate))
  const [saving, setSaving] = useState(false)

  async function save() {
    setSaving(true)
    await saved(
      onSave({
        removalReason: reason ?? '',
        termLetterDate: toIsoDate(termLetter),
        lastLoadDate: toIsoDate(lastLoad),
      })
    )
    setSaving(false)
  }

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{KIND_LABELS[line.kind]}</DialogTitle>
        </DialogHeader>
        <RemovalFields
          kind={line.kind}
          reason={reason}
          termLetter={termLetter}
          lastLoad={lastLoad}
          onReason={setReason}
          onTermLetter={setTermLetter}
          onLastLoad={setLastLoad}
        />
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" onClick={() => void save()} loading={saving ? 'Saving…' : undefined}>
            Save change
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
